module.exports = {
	"nav": [
		{
			"name": "组件",
			"path": "/"
		}
	],
	"leftnav": [
		{
			"name": "使用",
			"path": "/"
		},
		{
			"name": "颜色",
			"path": "/color"
		},
		{
			"name": "字体",
			"path": "/font"
		},
		{
			"name": "Components",
			"path": "/components",
			"child": [
				{
					"title": "Basic",
					"components": [
						{
							"name": "Button",
							"cn": "按钮",
							"path": "/button"
						},
						{
							"name": "Svg",
							"cn": "图标",
							"path": "/svg"
						}
					]
				},
				{
					"title": "Form Controls",
					"components": [
						{
							"name": "Input",
							"cn": "输入框",
							"path": "/input"
						},
						{
							"name": "Checkbox",
							"cn": "多选框",
							"path": "/checkbox"
						},
						{
							"name": "Radio",
							"cn": "单选框",
							"path": "/radio"
						}
					]
				},
				{
					"title": "Views",
					"components": [
						{
							"name": "Alert",
							"cn": "警告提示",
							"path": "/alert"
						},
						{
							"name": "Message",
							"cn": "全局提醒",
							"path": "/message"
						},
						{
							"name": "Modal",
							"cn": "对话框",
							"path": "/modal"
						},
						{
							"name": "Notification",
							"cn": "通知提醒框",
							"path": "/notification"
						},
						{
							"name": "Popconfirm",
							"cn": "气泡确认框",
							"path": "/popconfirm"
						},
						{
							"name": "Popover",
							"cn": "气泡卡片",
							"path": "/popover"
						},
						{
							"name": "Tooltip",
							"cn": "文字提醒",
							"path": "/tooltips"
						},
						{
							"name": "Select",
							"cn": "选择器",
							"path": "/select"
						}
					]
				},
				{
					"title": "Data Display",
					"components": [
						{
							"name": "Tag",
							"cn": "便签",
							"path": "/tag"
						},
						{
							"name": "Pagination",
							"cn": "分页",
							"path": "/pagination"
						},
						{
							"name": "Collapse",
							"cn": "折叠面板",
							"path": "/collapse"
						},
						{
							"name": "DatePicker",
							"cn": "日期选择框",
							"path": "/datepicker"
						}
					]
				},
				{
					"title": "Other",
					"components": [
						{
							"name": "Loading",
							"cn": "加载条",
							"path": "/loading"
						}
					]
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./doc/nav.config.json
// module id = 12
// module chunks = 27